import { useMemo } from "react";

const labels = {
  English: {
    Jobs: "Jobs",
    ActiveJobs: "Active Jobs",
    JobName: "Job Name",
    Vacancies: "Vacancies",
    Department: "Department",
    HiringManager: "Hiring Manager",
    PostedDate: "Posted Date",
    Actions: "Actions",
    Applicants: "Applicants",
    ManageAndTrack:
      "Manage and track your potential hires through the reference checking process.",
    SearchApplicants: "Search applicants...",
    ApplicantsList: "Applicants List",
    Overview: "Overview of all applicants in the system.",
    Name: "Name",
    Email: "Email",
    Status: "Status",
    MonitorAndTrack:
      "Monitor and track potential hires, check their status, and access their details.",
    ViewDetails: "View Details",
    Edit: "Edit",
    Delete: "Delete",
    CandidateNotFound: "Applicant not found",
    NoCandidateRecord: "No applicant record",
    CultureFit: "Culture Fit",
    NotRated: "Not Rated",
    Status_InProgress: "In Progress",
    Status_Completed: "Completed",
    Status_Pending: "Pending",
    Status_Accept: "Accept",
    Status_Reject: "Reject",
    EditApplicant: "Edit Applicant",
    UpdateDetails: "Update the details of the applicant below.",
    jobName: "Job Name",
    SelectPosition: "Select a position",
    ReferenceFormat: "Reference Format",
    NoCustomQuestions: "No custom questions available",
    Applicant: "Applicant",
    UpdateCandidate: "Update Applicant",
    hrHatch: "Snappcheck",
    custom: "Custom Questionnaire",
    StandardFormat: "Standard Format",
    ManagementFormat: "Management Format",
    ExecutiveFormat: "Executive Format",
    FormatValues: {
      STANDARD: "Standard Format",
      MANAGEMENT: "Management Format",
      EXECUTIVE: "Executive Format",
    },
    ApplicantId: "Applicant ID:",
    AppliedDate: "Applied Date",
    SendEmail: "Send Email",
    NA: "N/A",
    Status_New: "New",
    Status_Failed: "Failed",
    Status_Accepted: "Accepted",
    Status_Rejected: "Rejected",
    standardFormat: "Standard Format",
    managementFormat: "Management Format",
    executiveFormat: "Executive Format",
    sending: "Sending...",
    ReminderSent: "Reminder Sent Successfully",
    DeleteConfirmation:
      "Are you sure you want to delete this applicant? Deleting this applicant will also remove all associated reference records.",
    Yes: "Yes",
    No: "No",
  },
  Japanese: {
    Jobs: "求人",
    ActiveJobs: "求人",
    JobName: "職種名",
    Vacancies: "求人情報",
    Department: "部門",
    HiringManager: "採用担当者",
    PostedDate: "掲載日",
    Actions: "操作",
    Applicants: "応募者",
    ManageAndTrack:
      "リファレンスチェックプロセスを通じて、潜在的な採用者を管理し追跡します。",
    SearchApplicants: "応募者を検索...",
    ApplicantsList: "応募者リスト",
    Overview: "システム内のすべての応募者の概要。",
    Name: "名前",
    Email: "メール",
    Status: "ステータス",
    MonitorAndTrack:
      "潜在的な採用者を監視し、彼らのステータスを確認し、詳細をアクセスします。",
    ViewDetails: "詳細を見る",
    Edit: "編集",
    Delete: "削除",
    CandidateNotFound: "応募者が見つかりません",
    NoCandidateRecord: "応募者記録なし",
    CultureFit: "文化適合性",
    NotRated: "未評価",
    Status_InProgress: "進行中",
    Status_Completed: "完了",
    Status_Pending: "保留中",
    Status_Accept: "承認",
    Status_Reject: "却下",
    EditApplicant: "応募者を編集",
    UpdateDetails: "以下の応募者の詳細を更新してください。",
    jobName: "職位",
    SelectPosition: "職位を選択",
    ReferenceFormat: "リファレンス形式",
    NoCustomQuestions: "カスタム質問はありません",
    Applicant: "応募者",
    UpdateCandidate: "応募者を更新",
    hrHatch: "HRハッチ",
    custom: "カスタムアンケート",
    StandardFormat: "標準フォーマット",
    ManagementFormat: "管理職フォーマット",
    ExecutiveFormat: "エグゼクティブフォーマット",
    FormatValues: {
      STANDARD: "標準フォーマット",
      MANAGEMENT: "管理職フォーマット",
      EXECUTIVE: "エグゼクティブフォーマット",
    },
    ApplicantId: "応募者ID:",
    AppliedDate: "応募日",
    Edit: "編集",
    SendEmail: "メール送信",
    NA: "該当なし",
    Status_New: "新規",
    Status_Failed: "失敗",
    Status_Accepted: "承認済み",
    Status_Rejected: "却下済み",
    standardFormat: "標準フォーマット",
    managementFormat: "マネジメントフォーマット",
    executiveFormat: "エグゼクティブフォーマット",
    sending: "送信中...",
    ReminderSent: "リマインダー送信済み",
    DeleteConfirmation:
      "この応募者を削除してもよろしいですか？この応募者を削除すると、関連するすべての参照記録も削除されます。",
    Yes: "はい",
    No: "いいえ",
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
